/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tools_Badge_GenericInputs */



/**
* | output |
* | --- |
* | "Ships tool calls for chat" |
*
* @param {Spaces_Tools_Badge_GenericInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tools_badge_generic = /** @type {((inputs?: Spaces_Tools_Badge_GenericInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tools_Badge_GenericInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bringt Tool-Aufrufe für den Chat mit")
	return /** @type {LocalizedString} */ ("Ships tool calls for chat")
});